<template>
<div>
  <div v-for="item in items" class="headline-cont selected-news-cont">
    <h1>{{ item.title }}</h1>
    <h4>{{ item.published }}</h4>
    <p>{{ item.intro }}</p>
    <button class="button-more"><a :href="item.link">{{ item.readmore }}</a></button>
    <a :href="item.link" class="box-link"></a>
  </div>
</div>
</template>
<script>
export default {
  props: ["items"],
  mounted() {
    scrollAnimations(this.$el);
  },
}
</script>
